import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const SubscriptionModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    const handleClose = () => {
        localStorage.setItem('subscriptionModalShown', 'true');
        onClose();
    };

    const handleLinkClick = () => {
        handleClose();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
                <div className="flex justify-center mb-4">
                    <Image src="/images/Abo-abgelaufen.png" alt="Pro-Abo abgelaufen" width={300} height={300} />
                </div>
                <h2 className="text-left text-2xl font-semibold mb-4">Oh nein, dein Pro-Abo ist abgelaufen!</h2>
                <p className="text-left mb-4">
                    Wir wissen, es ist schwer, sich von den Pro-Vorteilen zu trennen. Warum nicht einfach verlängern und weiter genießen?
                </p>
                <p className="text-left mb-4">
                    Kein Fan von Abos? Kein Problem! Hol dir den Lifetime-Zugang für nur 49,90 € und genieße die Vorteile für immer.
                </p>
                <div className="flex justify-end">
                    <button
                        className="bg-gray-300 text-gray-800 py-2 px-4 rounded mr-2 hover:bg-gray-400"
                        onClick={handleClose}
                    >
                        Schließen
                    </button>
                    <Link legacyBehavior href="/payment?plan=lifetime">
                        <a className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700" onClick={handleLinkClick}>
                            Lifetime kaufen
                        </a>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionModal;
